import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { BoSession } from "models/BO/BoSession";
import { formatDateTime, formatTime } from "utils/globalsUtils";
import React, { useEffect, useState } from "react";
import { getSystemUserSessionsDO } from "utils/systemUsersUtils";
interface SessionsTableProps {
  sessions?: BoSession[];
  userId?: string;
}

export const SessionsTable: React.FC<SessionsTableProps> = ({ sessions, userId }) => {
  const [_sessions, setSessions] = useState<BoSession[]>([]);
  useEffect(() => {
    if (userId) {
      getSystemUserSessionsDO(userId).then((sessions) => {
        setSessions(sessions);
      });
    }
  }, [userId]);
  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "Session ID",
      width: 120,
    },
    {
      field: "created",
      headerName: "Created",
      width: 180,
      valueGetter: (v) => formatDateTime(v),
    },
    {
      field: "lastPing",
      headerName: "Last Ping",
      width: 180,
      valueGetter: (v) => formatDateTime(v),
    },
    {
        field: "time",
        headerName: "Time",
        width: 120,
        valueGetter: (v, row) => {
            const now = new Date();
            const sessionTime = new Date(row.created);
            const lastPing = new Date(row.lastPing);
            const diff = lastPing.getTime() - sessionTime.getTime();
            return formatTime(diff);
        }
    }
  ];

  return (
    <DataGridPro
      rows={_sessions.map((s) => ({ ...s, id: s.id }))}
      columns={columns}
      density="compact"
      autoHeight
      hideFooter
      getRowId={(row) => row.id}
    />
  );
}; 